import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { Stack, Typography as MuiTypography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { AnchoredPopover, Button, FoodsIcon, Typography } from "@foodpilot/foods";
import { Fragment, useState } from "react";
import ImportIcon from "src/assets/icons/import.svg?react";
import { ComingSoonBadge } from "src/components/ComingSoonBadge";
import { CreateNewMenuItem } from "src/components/CreateNewMenuItem";
import { CREATE, SUPPLIER, useFoodpilotContext } from "src/context/FoodpilotContext.tsx";
import { URLHandler } from "src/services/URLHandler";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

export const SupplierPopover = () => {
    const { t } = useTranslation();
    const { canUser } = useFoodpilotContext();
    const isProductUxV2 = useIsProductUxV2();

    const [anchor, setAnchor] = useState<null | HTMLElement>(null);
    const isOpen = Boolean(anchor);

    return (
        <Fragment>
            {canUser(CREATE, SUPPLIER) && (
                <Button
                    variant="primary"
                    id="create-product-button"
                    onClick={(e) => setAnchor(e.currentTarget)}
                    endIcon={isProductUxV2 ? <FoodsIcon icon="arrowDownShort" size={1} /> : <KeyboardArrowDown />}
                >
                    {t("creer_un_nouveau_fournisseurs")}
                </Button>
            )}
            <AnchoredPopover
                variant="themed"
                anchor={anchor}
                open={isOpen}
                onClose={() => setAnchor(null)}
                anchorPosition="rightside"
            >
                <SupplierMenu isProductUxV2={isProductUxV2} />
            </AnchoredPopover>
        </Fragment>
    );
};

const SupplierMenu = ({ isProductUxV2 }: { isProductUxV2: boolean }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { selectedCompany } = useFoodpilotContext();

    if (selectedCompany === null) return;

    return (
        <Stack padding="0" gap="20px">
            <CreateNewMenuItem
                appearance={isProductUxV2 ? "product-v2" : "legacy"}
                onClick={() => {
                    const url = URLHandler.supplier.create(selectedCompany.id, 0);
                    navigate(url);
                }}
            >
                {isProductUxV2 ?
                    <FoodsIcon icon="add" size={2} />
                :   <AddCircleOutline />}
                {isProductUxV2 ?
                    <Typography sx={theme.custom.rowMenuElement}>{t("creer_un_fournisseur")}</Typography>
                :   <MuiTypography sx={theme.custom.rowMenuElement}>{t("creer_un_fournisseur")}</MuiTypography>}
            </CreateNewMenuItem>
            <CreateNewMenuItem appearance={isProductUxV2 ? "product-v2" : "legacy"} disabled>
                <ImportIcon />
                {isProductUxV2 ?
                    <Typography sx={theme.custom.rowMenuElement}>{t("importer_des_fournisseurs")}</Typography>
                :   <MuiTypography sx={theme.custom.rowMenuElement}>{t("importer_des_fournisseurs")}</MuiTypography>}
                <ComingSoonBadge />
            </CreateNewMenuItem>
        </Stack>
    );
};
